module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aries/ari_names-a2dbc8291a6463854066b739eca9ae09.gif";